module.exports = __webpack_public_path__ + "img/bg-towerv3@2x.18577916.png";